export default {
  state: {
    status: true,
    nav_items: [
      { title: 'Dashboard', icon: 'mdi-view-dashboard', route: '/dashboard' },
      { title: 'Audio File to Text', icon: 'mdi-file-compare', route: '/audio_file_to_text' },
      { title: 'ASR', icon: 'mdi-account-voice', route: '/ASR' },
      { title: 'Settings', icon: 'mdi-cog', route: '/setting' }
    ]
  },
  mutations: {
    SET_NAV_STATUS(state, payload) {
      state.status = payload
    }
  }
}
